import * as React from 'react'

const BriefAutofillQuestion = props => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <g>
        <circle cx="13" cy="13" r="13" fill="white" />
        <path
          d="M10.792 17.176L10.696 13.432H11.44C12.112 13.432 12.752 13.392 13.36 13.312C13.984 13.216 14.528 13.048 14.992 12.808C15.472 12.552 15.848 12.184 16.12 11.704C16.408 11.224 16.552 10.6 16.552 9.832C16.552 9.16 16.408 8.584 16.12 8.104C15.832 7.624 15.432 7.256 14.92 7C14.408 6.744 13.816 6.616 13.144 6.616C12.472 6.616 11.88 6.744 11.368 7C10.856 7.256 10.456 7.616 10.168 8.08C9.896 8.528 9.76 9.072 9.76 9.712H7.84C7.84 8.752 8.064 7.912 8.512 7.192C8.96 6.472 9.584 5.912 10.384 5.512C11.184 5.112 12.104 4.912 13.144 4.912C14.184 4.912 15.104 5.112 15.904 5.512C16.72 5.912 17.352 6.48 17.8 7.216C18.264 7.952 18.496 8.824 18.496 9.832C18.496 11.016 18.24 11.976 17.728 12.712C17.232 13.448 16.544 13.984 15.664 14.32C14.784 14.656 13.768 14.824 12.616 14.824L12.544 17.176H10.792ZM11.656 22.12C11.256 22.12 10.92 21.992 10.648 21.736C10.392 21.464 10.264 21.136 10.264 20.752C10.264 20.368 10.392 20.048 10.648 19.792C10.92 19.52 11.256 19.384 11.656 19.384C12.056 19.384 12.384 19.52 12.64 19.792C12.896 20.048 13.024 20.368 13.024 20.752C13.024 21.136 12.896 21.464 12.64 21.736C12.384 21.992 12.056 22.12 11.656 22.12Z"
          fill="#FF0000"
        />
      </g>
    </g>
  </svg>
)

export default BriefAutofillQuestion
